export default "__VITE_ASSET__$2Xg_sw2__"